import gql from 'graphql-tag';

export const getFeatureFlags = gql`
  query getFeatureFlags($features: [String!]) {
    ldFeatureFlags(features: $features) {
      code
      value
    }
  }
`;
